// extracted by mini-css-extract-plugin
export default {"tabTitle":"DashboardTabTitle_tabTitle__NnVkE","titleContainer":"DashboardTabTitle_titleContainer__po55c"};